import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'

import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'

import {
  CapitalButton,
} from '../Navigation/Buttons'

import {
  TextInput,
  isEmail,
} from '../Inputs/Inputs'

import styles from '../../../../css/home.module.css'

function AddCustomerStep1 ({ intl: { formatMessage, locale }, step1Callback, onSubmit }) {
  const [language, setLanguage] = useState(locale)
  const [invalid, setInvalid] = useState(true)
  const [saved, setSaved] = useState(false)
  const [email, setEmail] = useState('')

  const handleChange = useCallback((field, value) => {
    if (field === 'language') setLanguage(value)
    if (field === 'invalid') setInvalid(value)
    if (field === 'saved') setSaved(value)
    if (field === 'email') {
      setEmail(value)
      setInvalid(!isEmail(value))
    }
  }, [])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  const submitData = useCallback(() => {
    step1Callback(email)
  }, [email, step1Callback])

  let saveButtonStyle = `${styles.saveButton} saveButton`

  if (invalid) {
    saveButtonStyle = `${styles.saveButton} saveButton`
  } else if (saved === true) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonSuccess}`
  } else if (saved === 'error') {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonError}`
  }

  return (
    <div>
      <div className={styles.userInviteInput}>
        <section className={styles.userInput}>
          <FormattedMessage
            id='addCustomer.emailLookup'
            defaultMessage='Email'
            description='Email Lookup label'
            tagName='h5'
          />
          <div className={styles.userInputValueEdit}>
            <TextInput
              value={email}
              childChange={childChange}
              field='email'
            />
          </div>
        </section>
      </div>

      <CapitalButton
        text={formatMessage({
          id: 'customer.nextButton',
          defaultMessage: 'Next',
          description: '',
        })}
        buttonFunction={submitData}
        hSize='h2'
        style={saveButtonStyle}
        disabled={invalid}
      />
    </div>
  )
}

AddCustomerStep1.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    locale: PropTypes.string,
  }),
  step1Callback: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
}

export default injectIntl(AddCustomerStep1)
